module.exports = __webpack_public_path__ + "img/deleteBgImage.debd566e.svg";